<template>
  <b-modal 
    id="modal-confirm-hide-header-menu"
    header-class="align-items-center px-20 py-15"
    body-class="p-20"
    footer-class="px-20 py-15"
  >
    <template #modal-header>
      <div class="modal-title">
        <span class="fs-db-28">
          {{ $t('engine.manageHeader.widgetMenu.confirmHideMenu.lblTitle', languageEngine) }}
        </span>
      </div>
      <div
        id="close-modal-confirm-hide-header-menu"
        type="button"
        class="close-modal"
        aria-label="Close"
        @click="closeModal()"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div class="fs-sa-16">
        {{ $t('engine.manageHeader.widgetMenu.confirmHideMenu.lblDesc',languageEngine) }} <span class="text-primary">{{item_name}}</span> ?
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="blue" @click.prevent="confirm()">
        <i class="far fa-check"></i> 
        {{ $t('engine.manageHeader.widgetMenu.confirmHideMenu.lblSave',languageEngine) }}
      </b-button>
      <b-button variant="default" @click="closeModal()">
        <i class="far fa-times"></i>  
        {{ $t('engine.manageHeader.widgetMenu.confirmHideMenu.lblCancel',languageEngine) }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  methods: {
    closeModal() {
      this.$emit('clear');
      this.$bvModal.hide("modal-confirm-hide-header-menu");
    },
    confirm() {
      this.$emit('confirmed');
      this.$bvModal.hide("modal-confirm-hide-header-menu");
    }
  },
  props:['item_name']
}
</script>